import React from 'react'
import { Container } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton';
import s from './SearchResultsSkeleton.css'

function SearchResultsSkeleton() {
    return (
        <div className={s.allCategorySkeletonList}>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map(n => {
                return (
                    <div key={n} className={cx(s.allCategorySkeletonListItem, s[`allCategorySkeletonListItem${n}`])}>
                        <Skeleton className={s.allCategorySkeletonListItemImg} />
                        <Skeleton className={s.allCategorySkeletonListItemInfo} />
                    </div>
                )
            })}
        </div>
    )
}

export default withStyles(s)(SearchResultsSkeleton);
